// extracted by mini-css-extract-plugin
export default {"container":"styles_container__e3GhC","titleWrapper":"styles_titleWrapper__2KINv","title":"styles_title__lh68O","subtitle":"styles_subtitle__tYtbW"};